import React from "react"
import { Play, Trash2 } from "react-feather"
import { IMAGE_FILE_ACCEPT } from "../../../../helper/ImageValidation/ImageValidation"

// Get the file name from a file object or from a url string
function getFileName(file) {
    if (!file) return ""
    if (typeof file === "string") return file.split("/").pop()
    return file.name
}

// Dynamic video URL validation: supports local laptop links (localhost, local IP, port), relative paths, blob URLs, and any website/cloud host
export function isValidVideoUrl(url) {
    if (!url || typeof url !== "string") return false
    const trimmed = url.trim()
    if (!trimmed) return false

    // Reject plain text with whitespace
    if (/\s/.test(trimmed)) return false

    // Support local relative paths (e.g. /videos/demo.mp4 or ./uploads/video.mp4)
    if (trimmed.startsWith("/") || trimmed.startsWith("./") || trimmed.startsWith("../")) {
        return true
    }

    // Support blob or data URLs
    if (trimmed.startsWith("blob:") || trimmed.startsWith("data:video/")) {
        return true
    }

    try {
        const hasProtocol = /^https?:\/\//i.test(trimmed)
        const urlToTest = hasProtocol ? trimmed : `https://${trimmed}`
        const parsed = new URL(urlToTest)

        if (!["http:", "https:"].includes(parsed.protocol)) {
            return false
        }

        const hostname = parsed.hostname.toLowerCase()
        if (!hostname) return false

        // Allow laptop / local dev server (localhost, 127.0.0.1, local private IP ranges)
        const isLocalHost =
            hostname === "localhost" ||
            hostname === "127.0.0.1" ||
            /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
            /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
            /^172\.(1[6-9]|2\d|3[0-1])\.\d{1,3}\.\d{1,3}$/.test(hostname)

        // Allow local machine names with port (e.g. http://my-pc:3000/video.mp4)
        const hasPort = Boolean(parsed.port)
        const isSingleLabelHost = /^[a-z0-9]+(-[a-z0-9]+)*$/i.test(hostname) && (hasPort || isLocalHost)

        // Allow any other website domain or public IP
        const isDomainOrIP =
            /^([a-z0-9]+(-[a-z0-9]+)*\.)+[a-z]{2,}$/i.test(hostname) ||
            /^\d{1,3}(\.\d{1,3}){3}$/.test(hostname)

        return isLocalHost || isSingleLabelHost || isDomainOrIP
    } catch {
        return false
    }
}

export function VideoUploadSection({ number, box, thumbnailLoading, onVideoChange, onThumbnailChange, onRemoveThumbnailFile, onRemoveAll }) {
    return (
        <div className="seminar-video-upload-section">
            <div className="d-flex align-items-center justify-content-between mb-2">
                <strong>Video {number}</strong>
                <button type="button" className="seminar-remove-video" onClick={onRemoveAll}>
                    <Trash2 size={12} /> Remove Video
                </button>
            </div>

            <div className="seminar-video-upload-grid">
                <div>
                    <div className="seminar-video-field-label">Video URL</div>
                    <input
                        type="url"
                        name={`videoUrl_${number}`}
                        className={
                            box.video && typeof box.video === "string" && !isValidVideoUrl(box.video)
                                ? "form-control seminar-control is-invalid"
                                : "form-control seminar-control"
                        }
                        placeholder="Enter Video URL"
                        value={typeof box.video === "string" ? box.video : ""}
                        onChange={onVideoChange}
                    />
                    {box.video && typeof box.video === "string" && !isValidVideoUrl(box.video) && (
                        <div className="text-danger mt-1" style={{ fontSize: "11px" }}>
                            Please enter a valid video URL only.
                        </div>
                    )}
                    {box.video && typeof box.video === "string" && isValidVideoUrl(box.video) && (
                        <div className="mt-2">
                            <a
                                href={box.video}
                                target="_blank"
                                rel="noreferrer"
                                className="seminar-video-file-link d-inline-flex align-items-center gap-1"
                                title="Preview video in new tab"
                            >
                                <Play size={12} fill="currentColor" /> {box.video.split("/").pop().split("?")[0] || "Preview Video"}
                            </a>
                        </div>
                    )}
                </div>

                {/* <div>
                    <div className="seminar-video-field-label">Thumbnail Image</div>
                    <div className="seminar-video-dropzone seminar-thumbnail-dropzone">
                        <label className="btn btn-outline-primary seminar-choose-btn">
                            Choose Image
                            <input type="file" accept={IMAGE_FILE_ACCEPT} hidden disabled={Boolean(thumbnailLoading)} onChange={onThumbnailChange} />
                        </label>
                        <div className="seminar-upload-hint">JPG, PNG or JPEG</div>
                        {thumbnailLoading && <div className="d-flex align-items-center justify-content-center gap-2 text-primary mb-2" role="status"><span className="spinner-border spinner-border-sm" aria-hidden="true" />Loading image...</div>}
                        {box.preview && (
                            <img src={box.preview} alt={"Video " + number + " thumbnail"} className="seminar-video-thumbnail" />
                        )}
                        {box.thumbnail && (
                            <div className="seminar-video-file-row">
                                <span className="seminar-file-chip">{getFileName(box.thumbnail)}</span>
                                <button type="button" className="seminar-remove-link" onClick={onRemoveThumbnailFile}>Remove</button>
                            </div>
                        )}
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default VideoUploadSection
